import {
  IcErrorRhombusRegular,
  IcInformationCircleRegular,
  IcQuestionCircleLargeRegular,
  IcSuccessCircleRegular,
  IcWarningTriangleRegular,
} from '@kep/kcds-icons';

import type { ComponentType, SVGProps } from 'react';
import type { InlineMessageVariant } from './constants';

const iconComponentMap = {
  error: IcErrorRhombusRegular,
  warning: IcWarningTriangleRegular,
  information: IcInformationCircleRegular,
  success: IcSuccessCircleRegular,
  help: IcQuestionCircleLargeRegular,
} satisfies Record<InlineMessageVariant, ComponentType<SVGProps<SVGSVGElement>>>;

const InlineMessageIcon = (props: SVGProps<SVGSVGElement> & { variant: InlineMessageVariant }) => {
  const { variant, ...others } = props;

  const IconComponent = iconComponentMap[variant];

  return <IconComponent {...others} />;
};

export default InlineMessageIcon;
